export default "__VITE_ASSET__COnP05Z$__"